/* eslint-disable max-len */
import React from 'react'

export default function InputTimer({
    label1,
    placeholder1,
    htmlFor1,
    id1,
    label2,
    placeholder2,
    htmlFor2,
    id2,
    mainlabel,
    value,
    value2,
    value3,
    id3,
    handleOnChangeInput,
    data_testid1,
    data_testid2,
    timeFormat,
    emptyField,
    maxLength,
}) {
    
   
    return (
        <div className="flex flex-col" >
            <label className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title={mainlabel}>{mainlabel}</label>
            <div className={`w-full flex items-center border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA]'} rounded-lg px-3.5 py-[9px]`}>
                <div className='w-1/2 flex items-center relative'>
                    <label htmlFor={htmlFor1}></label>
                    <input 
                        id={id1} 
                        data-testid={data_testid1}
                        className={`text-base font-normal 
                text-[#000B17] w-full disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-sm outline-none appearance-none`}
                        onChange={(e) => {handleOnChangeInput(id1, e.target.value)}}
                        value={value}
                        autoComplete='off'
                        placeholder={placeholder1}/>
                        
                    
                    <div className='h-[20px] pr-2 flex flex-col absolute right-0 top-[2px] bg-white'>
                        <button className='pb-1.5 m-0 disabled:opacity-50' disabled={parseInt(value)>=12} onClick={()=>{handleOnChangeInput(id1,(value===""?"01":parseInt(value)+1).toString()?.padStart(2, '0'))}}><img src="/images/inputIncrement.svg" alt="img" className='h-fit'/></button>
                        <button className='pt-1.5 m-0 disabled:opacity-50 rotate-[180deg] ' disabled={parseInt(value)<=1} onClick={()=>{handleOnChangeInput(id1,(value===""?"1":parseInt(value)-1).toString()?.padStart(2, '0'))}}><img src="/images/inputIncrement.svg" alt="img" className='h-fit' /></button>
                    </div>
                </div>
                <span className='text-xl font-semibold text-[#000000]'>:</span>
                <div className='w-1/2 flex items-center relative'>
                    <label htmlFor={htmlFor2}></label>
                    <input id={id1} min={0} max={12} 
                        autoComplete='off'
                        data-testid={data_testid2}
                        value={value2}
                        className={`text-base font-normal 
                text-[#000B17] w-full disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-sm outline-none appearance-none pl-2`}
                        onChange={(e) => {handleOnChangeInput(id2, e.target.value)}}
                        placeholder={placeholder2}/>
                        
                    <div className='h-[20px] pr-2 flex flex-col absolute right-0 top-[2px] bg-white'>
                        <button className='pb-1.5 m-0 disabled:opacity-50' 
                            disabled={value2 === "30"} 
                            onClick={() => handleOnChangeInput(id2, "30")}>
                            <img src="/images/inputIncrement.svg" alt="img" className='h-fit' />
                        </button>
                        <button className='pt-1.5 m-0 disabled:opacity-50 rotate-[180deg]' 
                            disabled={value2 === "00"} 
                            onClick={() => handleOnChangeInput(id2, "00")}>
                            <img src="/images/inputIncrement.svg" alt="img" className='h-fit' />
                        </button>
                    </div>
                </div>
                {timeFormat && 
                <button
                    className='w-[50px] rounded bg-[#CCE7E7] h-full py-1 text-sm font-semibold text-[#008586]'
                    onClick={()=>{handleOnChangeInput(id3,value3)}} // Attach the onClick handler
                >
                    {<span>{value3}</span>}
                </button>
             
                }
            </div>
        </div>
    )
}
